import Box from '@mui/material/Box';
import React, { useState } from 'react';
import Container from '@mui/material/Container';

import useStyles from './Styles/AccountFormStyles';
import SignUpForm from './SignUpForm';
import LoginForm from './LoginForm';
import { Footer, Header, MixPanelTrackedLink } from '../../components';
import { useEffect } from 'react';
import { UserService } from '../../services/storage.service';
import { useNavigate } from 'react-router-dom';
import { WEB_URL } from '../../api/URLs';

export function LoginSignupScreen() {
    
    const classes = useStyles();
    const navigate = useNavigate();
    const [showSignupForm, setShowSignupForm] = useState(false);

    useEffect(() => {
        if (UserService.isLoggedIn())
            navigate(WEB_URL.PROFILE())
    }, [])

    return (<React.Fragment>
        <Header />
        <Box className="App-content loginSignup">
            <Container className={classes.mainContainer}>
                <Container component="main" maxWidth="sm" className={classes.formOuter}>
                    <Box className={classes.formContainer}>
                        <Box noValidate sx={{ mt: 1, textAlign: 'center' }}>
                            {
                                showSignupForm ? <SignUpForm /> : <LoginForm />
                            }
                            <MixPanelTrackedLink
                                type="button"
                                label="Already have an account?"
                                context="Redirecting to signup form link"
                                onClick={() => setShowSignupForm(!showSignupForm)}
                                sx={{ fontWeight: 600, fontSize: '1rem' }}
                            >
                                {showSignupForm ? 'Already have an account?' : 'Create an account'}
                            </MixPanelTrackedLink>
                        </Box>
                    </Box>
                </Container>
            </Container>
        </Box>
        <Footer />
    </React.Fragment>
    );
}